export class Stay {
  numberOfChildren?: number;
  numberOfAdults: number;
  numberOfRooms: number;
  numberOfNights: number;
  checkInDate: Date;
  checkOutDate: Date;
  totalPrice: number;
  constructor(checkInDate?: Date, checkOutDate?: Date) {
    this.checkInDate = checkInDate;
    this.checkOutDate = checkOutDate;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/stay.model.ts